import tw from "twin.macro"

export const Separator = tw.hr`block box-border h-separator border-0 border-t border-separator`
